<script setup lang="ts">
import { PropType } from 'vue';
import { ReadmissionHistory } from '../services/ReadmissionManagerRunner';

const props = defineProps({
  prevAdmission: {
    type: Object as PropType<ReadmissionHistory>,
    required: true,
  },
});
const otherPrevAdmission = props.prevAdmission?.prevAdmission;
</script>

<template>
  <tr>
    <td class="admission-date-cell" v-html="prevAdmission.admissionDate"></td>
    <td class="case-id-cell" v-html="prevAdmission.caseId"></td>
  </tr>
  <recursive-readmission-history
    :prev-admission="otherPrevAdmission"
    v-if="otherPrevAdmission"
  ></recursive-readmission-history>
</template>
